import styled from 'styled-components';
import imageHelper from '@utils/imageHelper';
import Paper from '@base/Paper/Paper';
import H3 from '@base/H3/H3';
import { BgColors, Spacings, TextColors } from '@styles/index';
import H5 from '@base/H5/H5';

const Container = styled.div`
  margin-top: ${Spacings.SPACING_28B};
  margin-bottom: 114px;
  grid-column: span 24;
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${Spacings.SPACING_3B};
  @media (max-width: 47.95em) {
    margin-top: ${Spacings.SPACING_18B};
    margin-bottom: ${Spacings.SPACING_6B};
    grid-template-columns: repeat(1, 1fr);
    grid-gap: ${Spacings.SPACING_6B};
    padding: 0 ${Spacings.SPACING_4B};
  }
`;

const Card = styled(Paper)`
  height: 208px;
  padding: 0px;
  overflow: hidden;
`;

const CardCover = styled.div`
  height: 120px;
  width: 100%;
  position: relative;
  background-color: ${({ $bgColor }) => $bgColor};
  padding: ${Spacings.SPACING_4B};
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

const CardImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  object-fit: contain;
`;

const CardContent = styled.div`
  padding-top: ${Spacings.SPACING_4B};
  padding-left: ${Spacings.SPACING_4B};
`;

const Description = styled(H5)`
  font-weight: 400;
  color: ${TextColors.LIGHT_GREY};
  @media (max-width: 70.95em) {
    font-size: 16px;
  }
`;

const StyledLink = styled.a`
  color: #08bd80;
  text-decoration: none;
`;

const cardsInfo = [
  {
    id: 1,
    title: 'Public relations',
    subTitle: 'For media enquiry email us at ',
    linkContent: 'press@unacademy.com',
    linkPosition: 'end',
    link: 'mailto:press@unacademy.com',
    bgColor: BgColors.GREEN,
    image: { src: 'about/relations.png', width: '106px', height: '106px' }
  },
  {
    id: 2,
    title: 'Contact us',
    subTitle: 'Shoot your questions to us at ',
    linkContent: 'contact@unacademy.com',
    linkPosition: 'end',
    link: 'mailto:contact@unacademy.com',
    bgColor: BgColors.BLUE,
    image: { src: 'about/contact-us.png', width: '128px', height: '96px' }
  }
];

function ConcatString({ card: _card }) {
  if (_card.link && _card.linkPosition && _card.linkContent) {
    if (_card.linkPosition === 'start')
      return (
        <>
          <StyledLink href={`${_card.link}`}>{_card.linkContent}</StyledLink>
          {_card.subTitle}
        </>
      );
    return (
      <>
        {_card.subTitle}
        <StyledLink href={`${_card.link}`}>{_card.linkContent}</StyledLink>
      </>
    );
  }
  return _card.subTitle;
}

const LeaderBlock = () => {
  return (
    <Container>
      {cardsInfo.map((_card) => (
        <Card key={_card.id}>
          <CardCover $bgColor={_card.bgColor}>
            <CardImage
              src={imageHelper.getImage(_card.image.src)}
              alt={_card.title}
              width={_card.image.width}
              height={_card.image.height}
            />
            <H3 color={TextColors.WHITE}>{_card.title}</H3>
          </CardCover>
          <CardContent>
            <Description>
              <ConcatString card={_card} />
            </Description>
          </CardContent>
        </Card>
      ))}
    </Container>
  );
};

export default LeaderBlock;
